import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { Carousel } from 'react-responsive-carousel';

import { NextIcon, PreviousIcon } from 'honeydew/icons/Carousels';
import useTailwindTheme from 'hooks/useTailwindTheme';

import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import styles from './thumbnailcarousel.module.css';

function ThumbnailCarousel({ images, isMisfits }) {
    const themedImageClass = isMisfits ? 'misfits-image' : 'imperfect-image';
    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });

    if (!images) return null;

    return (
        <Carousel
            showStatus={false}
            showIndicators={false}
            showArrows={!mobile}
            className={`${styles.carousel} ${styles[themedImageClass]}`}
            showThumbs={images.length > 1}
            renderArrowNext={(onClickHandler, hasNext) =>
                hasNext && (
                    <button className="next-button" type="button" onClick={onClickHandler}>
                        <NextIcon />
                    </button>
                )
            }
            renderArrowPrev={(onClickHandler, hasPrev) =>
                hasPrev && (
                    <button className="previous-button" type="button" onClick={onClickHandler}>
                        <PreviousIcon />
                    </button>
                )
            }
            preventMovementUntilSwipeScrollTolerance
        >
            {images.map(({ alt, height, src, width }) => (
                <img src={src} key={src} alt={alt} width={width} height={height} />
            ))}
        </Carousel>
    );
}

ThumbnailCarousel.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            alt: PropTypes.string.isRequired,
            height: PropTypes.string,
            src: PropTypes.string.isRequired,
            width: PropTypes.string,
        })
    ).isRequired,
    isMisfits: PropTypes.bool,
};

ThumbnailCarousel.defaultProps = { isMisfits: true };

export default ThumbnailCarousel;
